// 在url上增加传入的参数
export function urlAddUrlParam(url, urlParam) {
  var resultStr = '';
  for (var i in urlParam) {
    resultStr += "&" + i + "=" + urlParam[i];
  }
  return "" + url + resultStr;
}